import api from '@/services/Api';
import { List } from '@/models/common/List'
import { ProductCondition } from '@/models/recyclingModule/referentiel/ProductCondition'
import { ProductLight } from '@/models/referentiel/product/ProductLight'
import { RecyclerBac } from '@/models/recyclingModule/referentiel/RecyclerBac'
import { RecyclingBacStoreDetail } from '@/models/recyclingModule/referentiel/recyclingBacStoreDetail'

class RecyclingReferentialService {
  async getBuybackPriceByProductBoomerangId(productBoomerangId) {
    const response = await api.get(
      '/recycling/distributor/referential/buyback-price/' + productBoomerangId)
    return response.data
  }

  async getProductConditionList(productBoomerangId) {
    const response = await api.get(
        '/recycling/distributor/referential/all-product-condition/' + productBoomerangId)

    const productConditionList = [];
    for (let productCondition of response.data.item_list) {
      productConditionList.push(new ProductCondition(
        productCondition.technicalId,
        productCondition.productBoomerangId,
        productCondition.conditionTitle,
        productCondition.conditionDetail,
        productCondition.conditionOrder
      ))
    }

    return new List(
      response.data.count,
      productConditionList
    )
  }

  async getAllProductByManufacturer(manufacturerBoomerangId) {
    let encodedManufacturerBoomerangId = encodeURIComponent(manufacturerBoomerangId)
    const url = '/recycling/distributor/referential/all-product-by-manufacturer/'
      + encodedManufacturerBoomerangId

    const response = await api.get(url)

    const productList = [];
    for (let product of response.data.item_list) {
      productList.push(new ProductLight(
        product.technicalId,
        product.boomerangId,
        product.boomerangName
      ))
    }

    return new List(
      response.data.count,
      productList
    )
  }

  async getBacDetail(recyclingFolderBoomerangId) {
    const response = await api.get(
      '/recycling/distributor/referential/bac-detail/' + recyclingFolderBoomerangId)

    return new RecyclerBac(
      response.data.technicalId,
      response.data.boomerangId,
      response.data.designation,
      response.data.pictureName,
      response.data.pictureUrl,
      response.data.pictureQrCodeName,
      response.data.pictureQrCodeUrl,
      response.data.fillingThreshold,
      response.data.recyclerName,
      response.data.recyclerLogoName,
      response.data.recyclerLogoUrl
    )
  }

  async getRecyclingBacListByStore(storeBoomerangId) {
    const response = await api.get(
      '/recycling/distributor/referential/recycling-bac-list-by-store/' + storeBoomerangId)

    const bacList = [];
    for (let bac of response.data.item_list) {
      bacList.push(new RecyclingBacStoreDetail(
        bac.technicalId,
        bac.boomerangId,
        bac.designation,
        bac.fillingThreshold,
        bac.currentCount,
        bac.recyclerName,
        bac.recyclerLogoName,
        bac.recyclerLogoUrl
      ))
    }

    return new List(
      response.data.count,
      bacList
    )
  }
}

export default new RecyclingReferentialService()
